<template lang="pug">
.select-time
  .duration-segmented(:class="{ 'is-hidden': !showTimeOptions }" :aria-hidden="!showTimeOptions")
    button.time-option(type="button" @click="selectTime(1)" :class="{ selected: selectedTime === 1 }" :disabled="!showTimeOptions")
      span.duration-label {{ $t('pricing.time_options.monthly') }}
    button.time-option(type="button" @click="selectTime(6)" :class="{ selected: selectedTime === 6 }" :disabled="!showTimeOptions")
      span.duration-label {{ $t('pricing.time_options.semi_annual') }}
      span.discount-badge.is-orange {{ $t('pricing.10off') }}
    button.time-option(type="button" @click="selectTime(12)" :class="{ selected: selectedTime === 12 }" :disabled="!showTimeOptions")
      span.duration-label {{ $t('pricing.time_options.annual') }}
      span.discount-badge {{ $t('pricing.20off') }}
  //- removed: pricing.warning.e (赠送时长月均价说明)
</template>

<script lang="ts" setup>
const pricing = usePricing()
const selectedCate = computed(() => pricing.cate)
const purchaseType = computed(() => pricing.purchaseType)
const selectedTime = computed(() => pricing.time)
const showTimeOptions = computed(() => ['new_buy', 'extend'].includes(purchaseType.value.type) && selectedTime.value > 0 && !!selectedCate.value)

function selectTime(time: number | string) {
  if (!showTimeOptions.value) return
  pricing.time = Number(time)
  useScrollTo({ el: '#plan-list', offset: -200, mobileOnly: true })
}
</script>

<style lang="postcss" scoped>

.select-time {
  width: fit-content;
  min-width: 0;
  max-width: 100%;
  overflow: visible;
  margin-left: auto;
  margin-bottom: 0;
}

.duration-segmented {
  display: inline-flex;
  align-items: stretch;
  gap: 0.25rem;
  height: 3.25rem;
  padding: 0.3rem;
  border: 1px solid var(--pricing-border);
  border-radius: 0.85rem;
  background: var(--pricing-solid-surface);
  box-shadow: inset 0 1px 0 color-mix(in srgb, var(--pricing-white) 6%, transparent);
  overflow: visible;
  opacity: 1;
  visibility: visible;
  transition:
    opacity 0.18s ease,
    visibility 0.18s ease;
}

.duration-segmented.is-hidden {
  pointer-events: none;
  opacity: 0;
  visibility: hidden;
}

.time-option {
  position: relative;
  box-sizing: border-box;
  min-width: 6.75rem;
  min-height: 0;
  height: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  padding: 0 0.85rem;
  border: 1px solid transparent;
  border-radius: 0.55rem;
  background: transparent;
  color: var(--pricing-muted, var(--secondary-color));
  overflow: visible;
  cursor: pointer;
  font: inherit;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1;
  transition:
    background-color 150ms cubic-bezier(0.22, 1, 0.36, 1),
    border-color 150ms cubic-bezier(0.22, 1, 0.36, 1),
    color 150ms cubic-bezier(0.22, 1, 0.36, 1);
}

.time-option:hover {
  background: var(--pricing-solid-surface-strong);
  color: var(--pricing-text, var(--primary-color));
}

.time-option:disabled {
  cursor: default;
}

.time-option.selected {
  border-color: color-mix(in srgb, var(--pricing-text) 12%, transparent);
  background: var(--pricing-solid-surface-strong);
  color: var(--pricing-text, var(--primary-color));
  box-shadow: inset 0 1px 0 color-mix(in srgb, var(--pricing-white) 8%, transparent);
}

.duration-label {
  white-space: nowrap;
}

.discount-badge {
  position: absolute;
  top: -0.5rem;
  right: -0.25rem;
  z-index: 1;
  border-radius: 4px;
  background: var(--pricing-accent);
  color: var(--pricing-accent-foreground);
  font-size: 0.6875rem;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  line-height: 1;
  padding: 0.25rem 0.375rem;
  pointer-events: none;
  white-space: nowrap;
}

@media (max-width: 768px) {
  .select-time {
    width: 100%;
    margin-left: 0;
  }

  .duration-segmented {
    width: 100%;
    height: clamp(2.55rem, 8.5vw, 3.25rem);
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: clamp(0.08rem, 0.7vw, 0.25rem);
    padding: clamp(0.16rem, 0.8vw, 0.3rem);
    border-radius: clamp(0.68rem, 2.3vw, 0.85rem);
  }

  .time-option {
    min-width: 0;
    gap: clamp(0.08rem, 0.75vw, 0.35rem);
    padding: 0 clamp(0.12rem, 0.95vw, 0.35rem);
    border-radius: clamp(0.45rem, 1.7vw, 0.55rem);
    font-size: clamp(0.62rem, 2.35vw, 0.78rem);
  }

  .time-option:nth-child(1) {
    order: 3;
  }

  .time-option:nth-child(2) {
    order: 2;
  }

  .time-option:nth-child(3) {
    order: 1;
  }

  .discount-badge {
    top: clamp(-0.34rem, -0.9vw, -0.2rem);
    right: clamp(-0.2rem, -0.55vw, -0.08rem);
    padding: clamp(0.22rem, 0.85vw, 0.35rem) clamp(0.26rem, 1vw, 0.45rem);
    border-radius: clamp(0.28rem, 1vw, 0.35rem);
    font-size: clamp(0.52rem, 1.9vw, 0.7rem);
  }
}
</style>
